import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import Form from '../../components/forms/RequestFormAdding';
import { saveRequest, withRedirect, acceptRequest } from '../../CroActions';
import { isLegitimate, isPublic, isInternal } from '../../CroUtils';
import { breadcrumbs } from '../../../../actions/appActions';
import { convert, addressToForm } from '../../converts';

const postProcess = data => convert(data, {
  person: {
    address: addressToForm,
    deliveryAddress: addressToForm,
  },
  legalPerson: { address: addressToForm },
});
const selector = formValueSelector('requestForm');

const mapStateToProps = (state, { params, auth }) => ({
  loginData: (selector(state, 'person.firstName', 'person.lastName', 'person.id') || {}).person,
  breadcrumbsItems: [{ label: 'Žádosti o nahlédnutí na neveřejné oznámení' }, { label: 'Editace žádosti o nahlédnutí na neveřejné oznámení' }],
  aifo: selector(state, 'person.aifo'),
  legalPerson: selector(state, 'legalPerson') || '',
  officials: selector(state, 'officials') || [],
  state: selector(state, 'state') || '',
  url: `${auth.startUrl}/api/zadosti/${params.id}`,
  disabled: isLegitimate(auth) || isPublic(auth),
  postProcess,
  attachments: selector(state, 'attachments') || [],
  adminFiles: selector(state, 'adminFiles') || [],
  createdByPublic: selector(state, 'isPublic'),
  rejectText: selector(state, 'rejectText'),
  username: selector(state, 'applicant.username') || null,
  password: selector(state, 'applicant.plainPassword') || null,
  text: selector(state, 'text'),
});

const mapDispatchToProps = (dispatch, { params, auth }) => ({
  ...bindActionCreators({ breadcrumbs }, dispatch),
  onSubmit: (...args) => dispatch(withRedirect(saveRequest, `${auth.startUrl}/zadosti`)(...args)),
  accept: data => dispatch(withRedirect(() => async dispatch => {
    await saveRequest(data)(dispatch);
    await acceptRequest(data)(dispatch);
  }, `${auth.startUrl}/zadosti`)()),
  reject: () => dispatch(push(`${auth.startUrl}/zadosti/${params.id}/zamitnout`)),
  onShowHistory: (params.id && isInternal(auth))
    ? () => dispatch(push(`${auth.startUrl}/zadosti/${params.id}/historie`))
    : null,
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(Form);
